import { useSelector } from 'react-redux';
import React from 'react';

import { emptyObject } from 'ui-components/default-props/empty';

import { DataDrivenLogo } from '../../components/data-driven-logo';
import { getDisplayInformation } from '../../components/data-driven-logo/get-display-information';
import { getFulfillmentProviderDisplayName } from '../../components/data-driven-logo/get-fulfillment-provider-display-name';
import Global from '../../store/global-selectors';
import { InventoryService } from '../../services/inventory-service';

export const useInventorySource = (fulfillmentPlanId) => {
  const selectedShipFromId = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanShipFromId(state, {
      fulfillmentPlanId,
    }),
  );
  const selectedShipFrom = useSelector(
    (state) =>
      Global.selectSellerShipFromsById(state, {
        shipFromId: selectedShipFromId,
      }) || emptyObject,
  );
  const { inventorySourceType } = selectedShipFrom;

  const { inventorySourceDisplayName, inventorySourceIcon, inventorySourceId } =
    useSelector((state) => {
      if (selectedShipFrom.inventorySourceId === undefined) {
        const sellerFulfillmentProvider = Global.selectSellerFulfillmentProviderByProviderId(state, {
          shipFromId: selectedShipFromId,
        });

        if (sellerFulfillmentProvider) {
          const fulfillmentProviderId = parseInt(sellerFulfillmentProvider.fulfillmentProviderId, 10);
          const displayName = getFulfillmentProviderDisplayName(fulfillmentProviderId);

          return {
            inventorySourceDisplayName: displayName,
            inventorySourceIcon: <DataDrivenLogo fillProviderId={fulfillmentProviderId} type='icon' />,
            inventorySourceId: sellerFulfillmentProvider.fulfillmentProviderId,
          };
        }
      } else if (InventoryService.isInventorySourceTypeThirdParty(inventorySourceType)) {
        const { marketplaceId } =
          Global.selectSellerStoreData(state, {
            storeGuid: selectedShipFrom.inventorySourceId,
          }) || {};

        if (
          marketplaceId &&
          (inventorySourceType === InventoryService.InventorySourceType.Store ||
            inventorySourceType === InventoryService.InventorySourceType.ThirdParty)
        ) {
          const { name } = getDisplayInformation({ marketplaceId });

          return {
            inventorySourceDisplayName: name,
            inventorySourceIcon: <DataDrivenLogo marketplaceId={marketplaceId} type='icon' />,
            inventorySourceId: marketplaceId,
          };
        }
      }
    }) || {};

  return {
    displayName: inventorySourceDisplayName,
    icon: inventorySourceIcon,
    id: inventorySourceId,
    type: inventorySourceType,
  };
};
